import React from "react"
const MI_ic_instagram = props => {
  const { fill, style } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clip-path="url(#clip0_696_89)">
        <path
          d="M26.5212 0H5.47881C2.45781 0 0 2.45781 0 5.47881V26.5212C0 29.5422 2.45781 32 5.47881 32H26.5212C29.5422 32 32 29.5422 32 26.5212V5.47881C32 2.45781 29.5422 0 26.5212 0ZM31.0625 26.5212C31.0625 29.0252 29.0252 31.0625 26.5212 31.0625H5.47881C2.97475 31.0625 0.9375 29.0252 0.9375 26.5212V5.47881C0.9375 2.97475 2.97475 0.9375 5.47881 0.9375H26.5212C29.0252 0.9375 31.0625 2.97475 31.0625 5.47881V26.5212Z"
          fill={fill || "#646464"}
        />
        <path
          d="M16 7.01416C11.0452 7.01416 7.0141 11.0452 7.0141 16C7.0141 20.9548 11.0452 24.9859 16 24.9859C20.9548 24.9859 24.9858 20.9548 24.9858 16C24.9858 11.0452 20.9548 7.01416 16 7.01416ZM16 24.0484C11.5621 24.0484 7.9516 20.4379 7.9516 16C7.9516 11.5622 11.5621 7.95166 16 7.95166C20.4378 7.95166 24.0483 11.5622 24.0483 16C24.0483 20.4379 20.4378 24.0484 16 24.0484Z"
          fill={fill || "#646464"}
        />
        <path
          d="M25.5192 4.0083C24.1557 4.0083 23.0464 5.11761 23.0464 6.48105C23.0464 7.84455 24.1557 8.95386 25.5192 8.95386C26.8827 8.95386 27.9919 7.84455 27.9919 6.48105C27.9919 5.11755 26.8827 4.0083 25.5192 4.0083ZM25.5192 8.01636C24.6726 8.01636 23.9839 7.32761 23.9839 6.48105C23.9839 5.63449 24.6726 4.9458 25.5192 4.9458C26.3658 4.9458 27.0544 5.63455 27.0544 6.48105C27.0544 7.32755 26.3658 8.01636 25.5192 8.01636Z"
          fill={fill || "#646464"}
        />
        <path
          d="M12.0803 12.0803C13.999 10.1616 16.9963 9.91157 19.207 11.4859C19.4178 11.636 19.7106 11.5869 19.8608 11.3759C20.0109 11.1651 19.9617 10.8724 19.7508 10.7222C18.5169 9.84357 17.0025 9.42463 15.4868 9.54245C13.9524 9.6617 12.5071 10.3276 11.4173 11.4174C10.3275 12.5073 9.66163 13.9525 9.54232 15.4869C9.42451 17.0027 9.84351 18.517 10.7221 19.7509C10.8135 19.8793 10.9578 19.9478 11.1043 19.9478C11.1984 19.9478 11.2934 19.9195 11.3758 19.8608C11.5867 19.7106 11.6359 19.4179 11.4858 19.2071C9.91151 16.9963 10.1615 13.9991 12.0803 12.0803Z"
          fill={fill || "#646464"}
        />
        <path
          d="M20.6241 12.1392C20.4132 12.2894 20.364 12.5821 20.5141 12.793C22.0885 15.0037 21.8385 18.001 19.9197 19.9197C18.001 21.8384 15.0038 22.0885 12.793 20.5141C12.582 20.364 12.2894 20.4131 12.1392 20.6241C11.989 20.835 12.0383 21.1276 12.2491 21.2778C13.3465 22.0593 14.6656 22.4771 16.0105 22.4771C16.1777 22.4771 16.3455 22.4706 16.5131 22.4576C18.0476 22.3383 19.4928 21.6725 20.5826 20.5826C21.6724 19.4928 22.3383 18.0475 22.4576 16.5131C22.5754 14.9973 22.1565 13.483 21.2778 12.2491C21.1276 12.0383 20.835 11.989 20.6241 12.1392Z"
          fill={fill || "#646464"}
        />
      </g>
      <defs>
        <clipPath id="clip0_696_89">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default MI_ic_instagram
